const faqItems = [
  {
    q: '五一吃瓜网是什么平台？',
    a: '五一吃瓜网是一个专注于娱乐八卦与热点资讯的综合信息平台，每日聚合娱乐圈最新动态，涵盖明星绯闻、综艺内幕、网红热点、影视资讯等多个领域，帮助用户一站式获取最新最全的吃瓜内容。',
  },
  {
    q: '五一吃瓜网的内容来源可靠吗？',
    a: '平台内容均来自公开渠道和合作媒体，编辑团队会对每一条资讯进行多方核实与筛选，确保信息的真实性和准确性。对于未经证实的传闻，我们会明确标注来源与可信度，供读者自行判断。',
  },
  {
    q: '五一吃瓜网更新频率怎么样？',
    a: '我们实行全天候滚动更新机制，编辑团队7×24小时不间断追踪行业动态。重大热点事件发生后的最短时间内即可在平台看到相关报道，确保你不会错过任何重要资讯。',
  },
  {
    q: '如何向五一吃瓜网投稿或提供线索？',
    a: '欢迎通过平台「联系我们」板块提交线索或投稿。你可以提供文字、图片或视频素材，编辑团队将在收到后尽快审核处理。优质投稿将获得优先展示与署名机会。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-question-answer-line text-sm"></i>
            常见问题
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm mt-2">关于五一吃瓜网，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}